var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoggedinsession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191.738,
    height: 138.679,
    viewBox: "0 0 191.738 138.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7495",
    "data-name": "Caminho 7495",
    d: "M2219.909,161.679c20.479,4.049,30.95,27.247,63.953,47.9s25.743,101.295-26.379,88.134c-49.722-12.553-52.007-11.57-84.576-10.384C2132.151,288.775,2155.06,148.923,2219.909,161.679Z",
    transform: "translate(-2152.561 -160.856)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.501,
    x2: 1.001,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9c4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#ced6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#e8edf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#f7fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.002,
    y1: 0.501,
    x2: 0.999,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#01c0ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#01dade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#02e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02efee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.004,
    y1: 0.499,
    x2: 0.999,
    y2: 0.499,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 0.487,
    x2: 1.001,
    y2: 0.487,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.001,
    y1: 0.501,
    x2: 0.999,
    y2: 0.501,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.027,
    y1: 0.5,
    x2: 0.975,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.024,
    y1: 0.499,
    x2: 0.994,
    y2: 0.499,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb6c85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#ed7281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f18176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#f99b63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3934c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#3f39c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#4e47d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0.504,
    x2: 1,
    y2: 0.504,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_7532",
    x: 36.746,
    y: 55.461,
    width: 63.481,
    height: 67.549,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c4cded"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.118,
    y1: 0.486,
    x2: 0.905,
    y2: 0.525,
    xlinkHref: "#linear-gradient-10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logged_in_session",
    "data-name": "Logged in session",
    transform: "translate(-2133.2 -154.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6721",
    "data-name": "Grupo 6721",
    transform: "translate(2138.8 151.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6718",
    "data-name": "Grupo 6718",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6605",
    "data-name": "Grupo 6605",
    transform: "translate(0 2.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7480",
    "data-name": "Caminho 7480",
    d: "M2219.909,161.679c20.479,4.049,30.95,27.247,63.953,47.9s25.743,101.295-26.379,88.134c-49.722-12.553-52.007-11.57-84.576-10.384C2132.151,288.775,2155.06,148.923,2219.909,161.679Z",
    transform: "translate(-2152.561 -160.856)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6716",
    "data-name": "Grupo 6716",
    transform: "translate(0 2.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6715",
    "data-name": "Grupo 6715",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6698",
    "data-name": "Grupo 6698",
    transform: "translate(-27.149 14.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6608",
    "data-name": "Grupo 6608",
    transform: "translate(22.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6606",
    "data-name": "Grupo 6606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7481",
    "data-name": "Caminho 7481",
    d: "M2147.595,237.849V232.9h8.186V209.3h2.256v23.6h8.822v4.946h4.715V336.83H2137.5V237.849Z",
    transform: "translate(-2137.5 -209.3)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6607",
    "data-name": "Grupo 6607",
    transform: "translate(0 28.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2005",
    "data-name": "Ret\\xE2ngulo 2005",
    width: 4.715,
    height: 89.06,
    fill: "#d6d7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6610",
    "data-name": "Grupo 6610",
    transform: "translate(39.83 52.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2006",
    "data-name": "Ret\\xE2ngulo 2006",
    width: 34.102,
    height: 75.407,
    opacity: 0.22,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6609",
    "data-name": "Grupo 6609"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2007",
    "data-name": "Ret\\xE2ngulo 2007",
    width: 4.715,
    height: 75.407,
    fill: "#d6d7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6613",
    "data-name": "Grupo 6613",
    transform: "translate(130.307 52.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6611",
    "data-name": "Grupo 6611"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2008",
    "data-name": "Ret\\xE2ngulo 2008",
    width: 34.102,
    height: 75.407,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6612",
    "data-name": "Grupo 6612"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2009",
    "data-name": "Ret\\xE2ngulo 2009",
    width: 4.715,
    height: 75.407,
    fill: "#d6d7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6641",
    "data-name": "Grupo 6641",
    transform: "translate(72.977 16.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6614",
    "data-name": "Grupo 6614"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2010",
    "data-name": "Ret\\xE2ngulo 2010",
    width: 45.73,
    height: 111.274,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6615",
    "data-name": "Grupo 6615"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2011",
    "data-name": "Ret\\xE2ngulo 2011",
    width: 4.715,
    height: 111.274,
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6616",
    "data-name": "Grupo 6616",
    transform: "translate(33.784 5.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2012",
    "data-name": "Ret\\xE2ngulo 2012",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6617",
    "data-name": "Grupo 6617",
    transform: "translate(21.751 5.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2013",
    "data-name": "Ret\\xE2ngulo 2013",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6618",
    "data-name": "Grupo 6618",
    transform: "translate(33.784 16.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2014",
    "data-name": "Ret\\xE2ngulo 2014",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6619",
    "data-name": "Grupo 6619",
    transform: "translate(21.751 16.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2015",
    "data-name": "Ret\\xE2ngulo 2015",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6620",
    "data-name": "Grupo 6620",
    transform: "translate(9.719 16.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2016",
    "data-name": "Ret\\xE2ngulo 2016",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6621",
    "data-name": "Grupo 6621",
    transform: "translate(33.784 26.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2017",
    "data-name": "Ret\\xE2ngulo 2017",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6622",
    "data-name": "Grupo 6622",
    transform: "translate(9.719 26.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2018",
    "data-name": "Ret\\xE2ngulo 2018",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6623",
    "data-name": "Grupo 6623",
    transform: "translate(21.751 32.309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2019",
    "data-name": "Ret\\xE2ngulo 2019",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6624",
    "data-name": "Grupo 6624",
    transform: "translate(33.784 37.718)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2020",
    "data-name": "Ret\\xE2ngulo 2020",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6625",
    "data-name": "Grupo 6625",
    transform: "translate(21.751 43.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2021",
    "data-name": "Ret\\xE2ngulo 2021",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6626",
    "data-name": "Grupo 6626",
    transform: "translate(33.784 48.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2022",
    "data-name": "Ret\\xE2ngulo 2022",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6627",
    "data-name": "Grupo 6627",
    transform: "translate(9.719 48.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2023",
    "data-name": "Ret\\xE2ngulo 2023",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6628",
    "data-name": "Grupo 6628",
    transform: "translate(33.784 58.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2024",
    "data-name": "Ret\\xE2ngulo 2024",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6629",
    "data-name": "Grupo 6629",
    transform: "translate(21.751 58.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2025",
    "data-name": "Ret\\xE2ngulo 2025",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6630",
    "data-name": "Grupo 6630",
    transform: "translate(33.784 69.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2026",
    "data-name": "Ret\\xE2ngulo 2026",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6631",
    "data-name": "Grupo 6631",
    transform: "translate(21.751 69.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2027",
    "data-name": "Ret\\xE2ngulo 2027",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6632",
    "data-name": "Grupo 6632",
    transform: "translate(9.719 69.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2028",
    "data-name": "Ret\\xE2ngulo 2028",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6633",
    "data-name": "Grupo 6633",
    transform: "translate(33.784 80.064)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2029",
    "data-name": "Ret\\xE2ngulo 2029",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6634",
    "data-name": "Grupo 6634",
    transform: "translate(9.719 80.064)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2030",
    "data-name": "Ret\\xE2ngulo 2030",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6635",
    "data-name": "Grupo 6635",
    transform: "translate(21.751 85.473)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2031",
    "data-name": "Ret\\xE2ngulo 2031",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6636",
    "data-name": "Grupo 6636",
    transform: "translate(9.719 85.473)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2032",
    "data-name": "Ret\\xE2ngulo 2032",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6637",
    "data-name": "Grupo 6637",
    transform: "translate(33.784 90.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2033",
    "data-name": "Ret\\xE2ngulo 2033",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6638",
    "data-name": "Grupo 6638",
    transform: "translate(21.751 96.262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2034",
    "data-name": "Ret\\xE2ngulo 2034",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6639",
    "data-name": "Grupo 6639",
    transform: "translate(33.784 101.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2035",
    "data-name": "Ret\\xE2ngulo 2035",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6640",
    "data-name": "Grupo 6640",
    transform: "translate(9.719 101.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2036",
    "data-name": "Ret\\xE2ngulo 2036",
    width: 7.144,
    height: 2.979,
    fill: "#f5f5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6669",
    "data-name": "Grupo 6669",
    transform: "translate(153.794 24.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6642",
    "data-name": "Grupo 6642"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2037",
    "data-name": "Ret\\xE2ngulo 2037",
    width: 44.834,
    height: 102.973,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6643",
    "data-name": "Grupo 6643"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2038",
    "data-name": "Ret\\xE2ngulo 2038",
    width: 4.628,
    height: 102.973,
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6644",
    "data-name": "Grupo 6644",
    transform: "translate(33.119 4.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2039",
    "data-name": "Ret\\xE2ngulo 2039",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6645",
    "data-name": "Grupo 6645",
    transform: "translate(21.318 4.917)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2040",
    "data-name": "Ret\\xE2ngulo 2040",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6646",
    "data-name": "Grupo 6646",
    transform: "translate(33.119 14.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2041",
    "data-name": "Ret\\xE2ngulo 2041",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6647",
    "data-name": "Grupo 6647",
    transform: "translate(21.318 14.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2042",
    "data-name": "Ret\\xE2ngulo 2042",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6648",
    "data-name": "Grupo 6648",
    transform: "translate(9.516 14.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2043",
    "data-name": "Ret\\xE2ngulo 2043",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6649",
    "data-name": "Grupo 6649",
    transform: "translate(33.119 24.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2044",
    "data-name": "Ret\\xE2ngulo 2044",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6650",
    "data-name": "Grupo 6650",
    transform: "translate(9.516 24.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2045",
    "data-name": "Ret\\xE2ngulo 2045",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6651",
    "data-name": "Grupo 6651",
    transform: "translate(21.318 29.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2046",
    "data-name": "Ret\\xE2ngulo 2046",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6652",
    "data-name": "Grupo 6652",
    transform: "translate(33.119 34.883)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2047",
    "data-name": "Ret\\xE2ngulo 2047",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6653",
    "data-name": "Grupo 6653",
    transform: "translate(21.318 39.887)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2048",
    "data-name": "Ret\\xE2ngulo 2048",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6654",
    "data-name": "Grupo 6654",
    transform: "translate(33.119 44.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2049",
    "data-name": "Ret\\xE2ngulo 2049",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6655",
    "data-name": "Grupo 6655",
    transform: "translate(9.516 44.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2050",
    "data-name": "Ret\\xE2ngulo 2050",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6656",
    "data-name": "Grupo 6656",
    transform: "translate(33.119 54.118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2051",
    "data-name": "Ret\\xE2ngulo 2051",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6657",
    "data-name": "Grupo 6657",
    transform: "translate(21.318 54.118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2052",
    "data-name": "Ret\\xE2ngulo 2052",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6658",
    "data-name": "Grupo 6658",
    transform: "translate(33.119 64.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2053",
    "data-name": "Ret\\xE2ngulo 2053",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6659",
    "data-name": "Grupo 6659",
    transform: "translate(21.318 64.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2054",
    "data-name": "Ret\\xE2ngulo 2054",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6660",
    "data-name": "Grupo 6660",
    transform: "translate(9.516 64.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2055",
    "data-name": "Ret\\xE2ngulo 2055",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6661",
    "data-name": "Grupo 6661",
    transform: "translate(33.119 74.106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2056",
    "data-name": "Ret\\xE2ngulo 2056",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6662",
    "data-name": "Grupo 6662",
    transform: "translate(9.516 74.106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2057",
    "data-name": "Ret\\xE2ngulo 2057",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6663",
    "data-name": "Grupo 6663",
    transform: "translate(21.318 79.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2058",
    "data-name": "Ret\\xE2ngulo 2058",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6664",
    "data-name": "Grupo 6664",
    transform: "translate(9.516 79.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2059",
    "data-name": "Ret\\xE2ngulo 2059",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6665",
    "data-name": "Grupo 6665",
    transform: "translate(33.119 84.085)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2060",
    "data-name": "Ret\\xE2ngulo 2060",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6666",
    "data-name": "Grupo 6666",
    transform: "translate(21.318 89.089)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2061",
    "data-name": "Ret\\xE2ngulo 2061",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6667",
    "data-name": "Grupo 6667",
    transform: "translate(33.119 94.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2062",
    "data-name": "Ret\\xE2ngulo 2062",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6668",
    "data-name": "Grupo 6668",
    transform: "translate(9.516 94.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2063",
    "data-name": "Ret\\xE2ngulo 2063",
    width: 7,
    height: 2.748,
    fill: "#f5f5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6697",
    "data-name": "Grupo 6697",
    transform: "translate(0 57.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6670",
    "data-name": "Grupo 6670"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2064",
    "data-name": "Ret\\xE2ngulo 2064",
    width: 28.867,
    height: 70.23,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6671",
    "data-name": "Grupo 6671"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2065",
    "data-name": "Ret\\xE2ngulo 2065",
    width: 2.979,
    height: 70.23,
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6672",
    "data-name": "Grupo 6672",
    transform: "translate(21.318 3.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2066",
    "data-name": "Ret\\xE2ngulo 2066",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6673",
    "data-name": "Grupo 6673",
    transform: "translate(13.739 3.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2067",
    "data-name": "Ret\\xE2ngulo 2067",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6674",
    "data-name": "Grupo 6674",
    transform: "translate(21.318 10.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2068",
    "data-name": "Ret\\xE2ngulo 2068",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6675",
    "data-name": "Grupo 6675",
    transform: "translate(13.739 10.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2069",
    "data-name": "Ret\\xE2ngulo 2069",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6676",
    "data-name": "Grupo 6676",
    transform: "translate(6.132 10.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2070",
    "data-name": "Ret\\xE2ngulo 2070",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6677",
    "data-name": "Grupo 6677",
    transform: "translate(21.318 16.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2071",
    "data-name": "Ret\\xE2ngulo 2071",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6678",
    "data-name": "Grupo 6678",
    transform: "translate(6.132 16.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2072",
    "data-name": "Ret\\xE2ngulo 2072",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6679",
    "data-name": "Grupo 6679",
    transform: "translate(13.739 20.392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2073",
    "data-name": "Ret\\xE2ngulo 2073",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6680",
    "data-name": "Grupo 6680",
    transform: "translate(21.318 23.805)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2074",
    "data-name": "Ret\\xE2ngulo 2074",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6681",
    "data-name": "Grupo 6681",
    transform: "translate(13.739 27.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2075",
    "data-name": "Ret\\xE2ngulo 2075",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6682",
    "data-name": "Grupo 6682",
    transform: "translate(21.318 30.603)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2076",
    "data-name": "Ret\\xE2ngulo 2076",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6683",
    "data-name": "Grupo 6683",
    transform: "translate(6.132 30.603)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2077",
    "data-name": "Ret\\xE2ngulo 2077",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6684",
    "data-name": "Grupo 6684",
    transform: "translate(21.318 36.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2078",
    "data-name": "Ret\\xE2ngulo 2078",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6685",
    "data-name": "Grupo 6685",
    transform: "translate(13.739 36.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2079",
    "data-name": "Ret\\xE2ngulo 2079",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6686",
    "data-name": "Grupo 6686",
    transform: "translate(21.318 43.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2080",
    "data-name": "Ret\\xE2ngulo 2080",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6687",
    "data-name": "Grupo 6687",
    transform: "translate(13.739 43.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2081",
    "data-name": "Ret\\xE2ngulo 2081",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6688",
    "data-name": "Grupo 6688",
    transform: "translate(6.132 43.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2082",
    "data-name": "Ret\\xE2ngulo 2082",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6689",
    "data-name": "Grupo 6689",
    transform: "translate(21.318 50.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2083",
    "data-name": "Ret\\xE2ngulo 2083",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6690",
    "data-name": "Grupo 6690",
    transform: "translate(6.132 50.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2084",
    "data-name": "Ret\\xE2ngulo 2084",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6691",
    "data-name": "Grupo 6691",
    transform: "translate(13.739 53.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2085",
    "data-name": "Ret\\xE2ngulo 2085",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6692",
    "data-name": "Grupo 6692",
    transform: "translate(6.132 53.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2086",
    "data-name": "Ret\\xE2ngulo 2086",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6693",
    "data-name": "Grupo 6693",
    transform: "translate(21.318 57.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2087",
    "data-name": "Ret\\xE2ngulo 2087",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6694",
    "data-name": "Grupo 6694",
    transform: "translate(13.739 60.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2088",
    "data-name": "Ret\\xE2ngulo 2088",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6695",
    "data-name": "Grupo 6695",
    transform: "translate(21.318 64.155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2089",
    "data-name": "Ret\\xE2ngulo 2089",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6696",
    "data-name": "Grupo 6696",
    transform: "translate(6.132 64.155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2090",
    "data-name": "Ret\\xE2ngulo 2090",
    width: 4.512,
    height: 1.88,
    fill: "#f5f5ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6707",
    "data-name": "Grupo 6707",
    transform: "translate(-59.834 -19.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6700",
    "data-name": "Grupo 6700",
    transform: "translate(0 1.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2091",
    "data-name": "Ret\\xE2ngulo 2091",
    width: 138.984,
    height: 158.45,
    transform: "translate(1.533 1.822)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2092",
    "data-name": "Ret\\xE2ngulo 2092",
    width: 3.037,
    height: 162.326,
    transform: "translate(138.984 0.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7482",
    "data-name": "Caminho 7482",
    d: "M2089.889,264.665H2079.1L2136.921,110.9h10.789Z",
    transform: "translate(-2040.514 -107.255)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7483",
    "data-name": "Caminho 7483",
    d: "M2037.309,264.665H2031.9L2089.721,110.9h5.409Z",
    transform: "translate(-2006.967 -107.255)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7484",
    "data-name": "Caminho 7484",
    d: "M2259.98,305.249h-5.38L2304.148,168v11.049Z",
    transform: "translate(-2165.251 -147.839)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2093",
    "data-name": "Ret\\xE2ngulo 2093",
    width: 142.021,
    height: 4.194,
    transform: "translate(0 158.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6699",
    "data-name": "Grupo 6699",
    transform: "translate(92.675 0.839)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2094",
    "data-name": "Ret\\xE2ngulo 2094",
    width: 3.037,
    height: 160.678,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2095",
    "data-name": "Ret\\xE2ngulo 2095",
    width: 135.918,
    height: 1.273,
    transform: "translate(3.066 157.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2096",
    "data-name": "Ret\\xE2ngulo 2096",
    width: 142.021,
    height: 3.616,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2097",
    "data-name": "Ret\\xE2ngulo 2097",
    width: 135.976,
    height: 1.273,
    transform: "translate(3.037 3.645)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6703",
    "data-name": "Grupo 6703",
    transform: "translate(139.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2098",
    "data-name": "Ret\\xE2ngulo 2098",
    width: 138.984,
    height: 158.45,
    transform: "translate(2.227)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6701",
    "data-name": "Grupo 6701",
    transform: "translate(0 1.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2099",
    "data-name": "Ret\\xE2ngulo 2099",
    width: 3.037,
    height: 162.326,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7485",
    "data-name": "Caminho 7485",
    d: "M2486.989,264.665H2476.2L2534.021,110.9h10.789Z",
    transform: "translate(-2461.766 -105.954)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7486",
    "data-name": "Caminho 7486",
    d: "M2434.38,264.665H2429L2486.821,110.9h5.38Z",
    transform: "translate(-2428.219 -105.954)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7487",
    "data-name": "Caminho 7487",
    d: "M2740.48,305.249h-5.38L2784.678,168v11.049Z",
    transform: "translate(-2645.78 -146.538)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6702",
    "data-name": "Grupo 6702",
    transform: "translate(46.309 2.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2100",
    "data-name": "Ret\\xE2ngulo 2100",
    width: 3.037,
    height: 160.678,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2101",
    "data-name": "Ret\\xE2ngulo 2101",
    width: 142.021,
    height: 4.194,
    transform: "translate(0 159.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2102",
    "data-name": "Ret\\xE2ngulo 2102",
    width: 3.037,
    height: 160.678,
    transform: "translate(92.646 2.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2103",
    "data-name": "Ret\\xE2ngulo 2103",
    width: 135.918,
    height: 1.273,
    transform: "translate(3.037 158.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2104",
    "data-name": "Ret\\xE2ngulo 2104",
    width: 142.021,
    height: 3.616,
    transform: "translate(0 1.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2105",
    "data-name": "Ret\\xE2ngulo 2105",
    width: 135.976,
    height: 1.273,
    transform: "translate(3.008 4.946)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6704",
    "data-name": "Grupo 6704",
    transform: "translate(0 29.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2106",
    "data-name": "Ret\\xE2ngulo 2106",
    width: 286.009,
    height: 1.822,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6705",
    "data-name": "Grupo 6705",
    transform: "translate(0 78.242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2107",
    "data-name": "Ret\\xE2ngulo 2107",
    width: 286.009,
    height: 1.822,
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6706",
    "data-name": "Grupo 6706",
    transform: "translate(0 126.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2108",
    "data-name": "Ret\\xE2ngulo 2108",
    width: 286.009,
    height: 1.822,
    fill: "#f5f5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6714",
    "data-name": "Grupo 6714",
    transform: "translate(37.382 -6.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6708",
    "data-name": "Grupo 6708",
    transform: "translate(10.124 19.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7488",
    "data-name": "Caminho 7488",
    d: "M2327.213,213.713A10.425,10.425,0,0,1,2316.8,203.3h.492a9.921,9.921,0,1,0,19.842,0h.492A10.444,10.444,0,0,1,2327.213,213.713Z",
    transform: "translate(-2316.8 -203.3)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6709",
    "data-name": "Grupo 6709",
    transform: "translate(7.26 11.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7489",
    "data-name": "Caminho 7489",
    d: "M2320.032,175.1,2306.9,186h28.954Z",
    transform: "translate(-2306.9 -175.1)",
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7490",
    "data-name": "Caminho 7490",
    d: "M2295.655,207.4,2281.8,252.118h40.321l-13.1-44.718Z",
    transform: "translate(-2281.8 -187.008)",
    opacity: 0.22,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6710",
    "data-name": "Grupo 6710",
    transform: "translate(19.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2109",
    "data-name": "Ret\\xE2ngulo 2109",
    width: 1.273,
    height: 14.405,
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7491",
    "data-name": "Caminho 7491",
    d: "M2349.281,184.728H2345V181.6a1.494,1.494,0,0,1,1.5-1.5h1.244a1.494,1.494,0,0,1,1.5,1.5v3.124Z",
    transform: "translate(-2326.72 -167.604)",
    fill: "#f4bf62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6711",
    "data-name": "Grupo 6711",
    transform: "translate(17.876 19.814)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_652",
    "data-name": "Elipse 652",
    cx: 2.488,
    cy: 2.488,
    r: 2.488,
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7492",
    "data-name": "Caminho 7492",
    d: "M2347.593,216.172a2.133,2.133,0,0,1-1.562-1.186c-.058-.231-.405-.116-.347.087a2.362,2.362,0,0,0,1.793,1.446C2347.738,216.548,2347.825,216.2,2347.593,216.172Z",
    transform: "translate(-2327.201 -192.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6712",
    "data-name": "Grupo 6712",
    transform: "translate(5.901 11.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7493",
    "data-name": "Caminho 7493",
    d: "M2316.691,175.1,2302.2,186h28.954Z",
    transform: "translate(-2302.2 -175.1)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6713",
    "data-name": "Grupo 6713",
    transform: "translate(19.033 9.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7494",
    "data-name": "Caminho 7494",
    d: "M2349.538,173.19h-1.186a.766.766,0,0,1-.752-.752v-1.186a.766.766,0,0,1,.752-.752h1.186a.766.766,0,0,1,.752.752v1.186A.747.747,0,0,1,2349.538,173.19Z",
    transform: "translate(-2347.6 -170.5)",
    fill: "#d6d7f2"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6726",
    "data-name": "Grupo 6726",
    transform: "translate(2287.528 238.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6724",
    "data-name": "Grupo 6724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7497",
    "data-name": "Caminho 7497",
    d: "M2511.995,465.57a4.375,4.375,0,0,0,2.516-.839,20.694,20.694,0,0,1-.376,4.628c-.983,1.591-3.731,4.512-3.558,4.512a8.39,8.39,0,0,0,2.2-.521,17.9,17.9,0,0,1-1.677,2.748c-1.331,1.764-3.211,3.182-3.934,5.351-.029.058-.058.087-.087.087-.029.116-.145.2-.26.116-3.587-3.384-4.223-8.562-4.744-13.219a5.141,5.141,0,0,1-.058-.665,14.271,14.271,0,0,0,3.3,2.574c.174.087-2.227-3.76-3.413-5.554a9.926,9.926,0,0,1,.607-3.3,27.874,27.874,0,0,1,3.674-6.277c.058-.087.115-.145.173-.231a10.016,10.016,0,0,0,1.533,2.777,32.451,32.451,0,0,0-.491-4.194c.347-.434.694-.868,1.07-1.3.492-.55,1.07-1.5,1.909-1.388s2.719,3.529,2.979,4.483c.115.4.2.839.289,1.273.029.173.087.376.116.55.318,1.707.492,3.471.636,5.178l-.174.26C2513.5,463.661,2511.821,465.57,2511.995,465.57Z",
    transform: "translate(-2490.583 -450.867)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7498",
    "data-name": "Caminho 7498",
    d: "M2517.01,474.845a8.607,8.607,0,0,0,4.4-2.545c.2-.174-.058-.492-.232-.318a8.526,8.526,0,0,1-4.136,2.43c.376-2.632.81-5.235,1.331-7.868.058-.26-.347-.318-.4-.058-.694,3.442-1.244,6.942-1.678,10.413a17.784,17.784,0,0,1-2.343-4.686c-.087-.26-.463-.087-.376.145a17.35,17.35,0,0,0,2.516,4.946.159.159,0,0,0,.144.087c-.086.752-.173,1.533-.26,2.285a10.6,10.6,0,0,1-1.736-3.037c-.087-.231-.463-.087-.376.145a11.138,11.138,0,0,0,1.967,3.355c.029.029.058.058.086.058-.26,2.516-.463,5.033-.578,7.578,0,.029-.029.058-.029.087q-.086,1.388-.087,2.777c-.029.607-.029,1.215-.058,1.822a.221.221,0,0,0,.058.145,89.726,89.726,0,0,0,2.14,16.892c.145-.029.26-.058.405-.087a83.54,83.54,0,0,1-2.141-19.119c.029-.694.058-1.359.087-2.054a.136.136,0,0,0,.174-.029,6.373,6.373,0,0,0,1.851-1.88c.145-.2-.174-.463-.318-.26a6.962,6.962,0,0,1-1.678,1.764c.231-4.339.636-8.677,1.273-12.987Z",
    transform: "translate(-2498.866 -461.848)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7499",
    "data-name": "Caminho 7499",
    d: "M2466.887,507.659a4.183,4.183,0,0,1-2.372.2,15.723,15.723,0,0,0,1.649,3.355c1.3.868,4.483,2.169,4.31,2.227a9.568,9.568,0,0,1-2.025.347,12.027,12.027,0,0,0,2.227,1.5c1.649.9,3.674,1.331,4.917,2.719.029.029.058.058.087.058a.149.149,0,0,0,.26,0c2.054-3.731,1.1-7.81.2-11.483a3.481,3.481,0,0,0-.145-.521,12.331,12.331,0,0,1-2.054,3.008c-.115.116.81-3.558,1.3-5.293a7.729,7.729,0,0,0-1.475-2.285,20.921,20.921,0,0,0-4.946-3.5,1.744,1.744,0,0,0-.231-.116,8.288,8.288,0,0,1-.492,2.6,22.746,22.746,0,0,1-.81-3.3c-.434-.2-.839-.434-1.273-.607-.578-.26-1.359-.781-2.025-.4s-1.3,3.529-1.215,4.339c.029.347.087.694.116,1.041a2.256,2.256,0,0,1,.058.463,38.491,38.491,0,0,0,.955,4.107c.087.058.144.087.231.145A27.09,27.09,0,0,1,2466.887,507.659Z",
    transform: "translate(-2462.772 -482.976)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6722",
    "data-name": "Grupo 6722",
    transform: "translate(0.124 16.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7500",
    "data-name": "Caminho 7500",
    d: "M2483.157,539.53a63.884,63.884,0,0,0-3.095-13.392.088.088,0,0,0,0-.116c-.174-.463-.376-.9-.578-1.331-.29-.694-.579-1.359-.9-2.054,0-.029-.029-.029-.058-.058-.839-1.851-1.735-3.673-2.69-5.5l.058-.058a8.739,8.739,0,0,0,.694-3.182c0-.2-.347-.2-.376,0a9.018,9.018,0,0,1-.578,2.864c-.289-.55-.579-1.1-.9-1.649.058-.029.087-.058.087-.116a13.66,13.66,0,0,0,.694-4.541c0-.2-.376-.2-.376,0a13.868,13.868,0,0,1-.607,4.31c-1.388-2.488-2.864-4.917-4.455-7.289-.116-.174-.434,0-.318.174,1.186,1.793,2.343,3.616,3.413,5.467a8.362,8.362,0,0,1-4.223-.463c-.2-.058-.318.26-.116.318a8.437,8.437,0,0,0,4.483.463h0a102.339,102.339,0,0,1,4.831,9.372,6.018,6.018,0,0,1-1.938-.752c-.174-.116-.376.174-.2.289a6.043,6.043,0,0,0,2.112.81.217.217,0,0,0,.145-.029c.231.492.434,1.012.665,1.5a59.6,59.6,0,0,1,3.731,15.07A1.3,1.3,0,0,1,2483.157,539.53Z",
    transform: "translate(-2467.133 -507.351)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7501",
    "data-name": "Caminho 7501",
    d: "M2466.353,516.315a9.664,9.664,0,0,1-3.153-1.215,2.239,2.239,0,0,1,.058.463,9.278,9.278,0,0,0,2.95,1.1C2466.469,516.691,2466.556,516.344,2466.353,516.315Z",
    transform: "translate(-2463.2 -512.859)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7502",
    "data-name": "Caminho 7502",
    d: "M2545.957,523.3c-.029,1.446-3.384,2.169-4.454,2.545-2.372.868-4.686,1.764-6.421,3.673a76.606,76.606,0,0,0-5.612,7.318.432.432,0,0,1-.434.174,5.483,5.483,0,0,1-.492-1.07c-.607-1.5-1.562-4.281-1.331-5.843a10.179,10.179,0,0,1,1.07-3.153,2.766,2.766,0,0,0,.665,1.331,26.864,26.864,0,0,0,.376-2.921,4.446,4.446,0,0,1,.492-.55,11.794,11.794,0,0,1,1.244-1.157c.087-.087.2-.145.29-.231.376-.26.752-.521,1.128-.752.116-.058.2-.116.318-.174a10.1,10.1,0,0,1,1.128-.55,7.541,7.541,0,0,0,.636,2.083,14.406,14.406,0,0,0,.26-2.43,8.418,8.418,0,0,1,1.128-.347,6.562,6.562,0,0,0,.463,1.331,6.373,6.373,0,0,0,.723-1.62,15.383,15.383,0,0,1,3.615-.289,1.186,1.186,0,0,1,.318.029c.318.029.636.058.955.116,1.157.174,3.9.926,3.934,2.488Z",
    transform: "translate(-2508.548 -500.465)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6723",
    "data-name": "Grupo 6723",
    transform: "translate(19.698 22.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7503",
    "data-name": "Caminho 7503",
    d: "M2535.624,533.547c-2.864,2.835-3.76,8.012-3.934,9.487a5.871,5.871,0,0,0-.579,1.909,41.733,41.733,0,0,0-.174,7.115c.029.781.058,1.533.087,2.314.145-.029.26-.058.4-.087-.029-.492-.058-.983-.058-1.446-.058-2.112-.058-4.194.029-6.306a9.233,9.233,0,0,1,.579-3.182.227.227,0,0,0,.116-.116,81.6,81.6,0,0,1,5.611-7.318c1.764-1.909,4.049-2.777,6.421-3.673,1.07-.4,4.426-1.1,4.454-2.545C2544.1,530.25,2538.921,530.307,2535.624,533.547Z",
    transform: "translate(-2530.872 -528.919)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7504",
    "data-name": "Caminho 7504",
    d: "M2545.754,530.24a9.392,9.392,0,0,1-.058-3.24c-.115.058-.2.116-.318.174a9.452,9.452,0,0,0,.087,3.124C2545.493,530.5,2545.783,530.413,2545.754,530.24Z",
    transform: "translate(-2541.118 -527)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7505",
    "data-name": "Caminho 7505",
    d: "M2541.395,533.093a10.893,10.893,0,0,1-.4-2.893,2.028,2.028,0,0,0-.29.231,12.632,12.632,0,0,0,.405,2.748C2541.134,533.353,2541.423,533.295,2541.395,533.093Z",
    transform: "translate(-2537.857 -529.274)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6725",
    "data-name": "Grupo 6725",
    transform: "translate(6.979 41.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7506",
    "data-name": "Caminho 7506",
    d: "M2508,597.307a10.882,10.882,0,0,1-.231,2.2,10.581,10.581,0,0,1-4.107,6.306h-12.322a10.579,10.579,0,0,1-4.107-6.306,11.126,11.126,0,0,1-.231-2.2,9.881,9.881,0,0,1,.26-2.285,12.159,12.159,0,0,1,.578-1.822h19.351a9.574,9.574,0,0,1,.578,1.822A11.993,11.993,0,0,1,2508,597.307Z",
    transform: "translate(-2486.971 -593.2)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7507",
    "data-name": "Caminho 7507",
    d: "M2518.661,597.307a10.882,10.882,0,0,1-.231,2.2,10.579,10.579,0,0,1-4.107,6.306H2502c16.082.81,15.822-12.611,15.822-12.611a9.54,9.54,0,0,1,.579,1.822A10.065,10.065,0,0,1,2518.661,597.307Z",
    transform: "translate(-2497.632 -593.2)",
    fill: "#ff6b77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7508",
    "data-name": "Caminho 7508",
    d: "M2491.586,593.3h-3.847a12.185,12.185,0,0,0-.578,1.822,9.881,9.881,0,0,0-.26,2.285,10.881,10.881,0,0,0,.231,2.2,10.58,10.58,0,0,0,4.107,6.306h1.707C2490.921,604.407,2489.966,597.552,2491.586,593.3Z",
    transform: "translate(-2486.9 -593.271)",
    fill: "#fda798"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6762",
    "data-name": "Grupo 6762",
    transform: "translate(2133.56 213.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6729",
    "data-name": "Grupo 6729",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7509",
    "data-name": "Caminho 7509",
    d: "M2149.527,493.674h100.211a4.583,4.583,0,0,0,4.635-5.407l-8.883-68.259a6.415,6.415,0,0,0-6.145-5.407H2139.134a4.583,4.583,0,0,0-4.635,5.407l8.884,68.294A6.411,6.411,0,0,0,2149.527,493.674Z",
    transform: "translate(-2134.445 -414.6)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7510",
    "data-name": "Caminho 7510",
    d: "M2268.139,488.617H2167.963a6.414,6.414,0,0,1-6.145-5.407l-1.51-10.674-7.409-52.528a4.583,4.583,0,0,1,4.635-5.407h100.211a6.414,6.414,0,0,1,6.145,5.407l1.861,13.273,7.023,49.9A4.6,4.6,0,0,1,2268.139,488.617Z",
    transform: "translate(-2146.384 -414.6)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7511",
    "data-name": "Caminho 7511",
    d: "M2272.524,491.024h-92.346a5.926,5.926,0,0,1-5.688-4.986l-1.3-9.27-6.882-48.982a4.245,4.245,0,0,1,4.284-4.986h92.346a5.926,5.926,0,0,1,5.688,4.986l1.51,10.744,6.672,47.507A4.231,4.231,0,0,1,2272.524,491.024Z",
    transform: "translate(-2155.089 -419.921)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6727",
    "data-name": "Grupo 6727",
    transform: "translate(25.476 64.993)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2110",
    "data-name": "Ret\\xE2ngulo 2110",
    width: 11.341,
    height: 2.528,
    transform: "translate(120.225)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2111",
    "data-name": "Ret\\xE2ngulo 2111",
    width: 11.341,
    height: 2.528,
    transform: "translate(106.883)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2112",
    "data-name": "Ret\\xE2ngulo 2112",
    width: 11.341,
    height: 2.528,
    transform: "translate(93.505)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2113",
    "data-name": "Ret\\xE2ngulo 2113",
    width: 37.641,
    height: 2.528,
    transform: "translate(53.863)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2114",
    "data-name": "Ret\\xE2ngulo 2114",
    width: 11.341,
    height: 2.528,
    transform: "translate(40.063)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2115",
    "data-name": "Ret\\xE2ngulo 2115",
    width: 11.341,
    height: 2.528,
    transform: "translate(26.721)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2116",
    "data-name": "Ret\\xE2ngulo 2116",
    width: 11.341,
    height: 2.528,
    transform: "translate(13.343)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2117",
    "data-name": "Ret\\xE2ngulo 2117",
    width: 11.341,
    height: 2.528,
    fill: "#312da4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6728",
    "data-name": "Grupo 6728",
    transform: "translate(14.942 67.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7512",
    "data-name": "Caminho 7512",
    d: "M2183.707,618.517h136.131a6.706,6.706,0,0,0,6.707-6.706V607H2177v4.845A6.7,6.7,0,0,0,2183.707,618.517Z",
    transform: "translate(-2177 -606.965)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2118",
    "data-name": "Ret\\xE2ngulo 2118",
    width: 149.65,
    height: 4.249,
    transform: "translate(0.07)",
    fill: "url(#linear-gradient-13)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6739",
    "data-name": "Grupo 6739",
    transform: "translate(2171.445 209.603)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -38.25, -55.46)",
    filter: "url(#Caminho_7532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7532-2",
    "data-name": "Caminho 7532",
    d: "M2246.066,470.325c2.106,16.591-9.747,30.022-26.335,30.022s-31.869-13.431-33.711-30.022,9.746-30.023,26.335-30.023C2228.948,440.039,2243.958,453.733,2246.066,470.325Z",
    transform: "translate(-2147.58 -384.84)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7533",
    "data-name": "Caminho 7533",
    d: "M2239.676,467.873c1.844,14.485-8.427,26.072-22.909,26.072s-27.655-11.587-29.233-26.072c-1.845-14.485,8.427-26.073,22.911-26.073S2237.832,453.388,2239.676,467.873Z",
    transform: "translate(-2183.391 -437.846)",
    fill: "#e9eef8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8248",
    "data-name": "Caminho 8248",
    d: "M16.272,2.6a1.6,1.6,0,0,0-.588.227,1.58,1.58,0,0,0-.438.416A1.55,1.55,0,0,0,15,3.794a1.529,1.529,0,0,0-.015.62l2.441,14.6a1.527,1.527,0,0,0,.214.58,1.575,1.575,0,0,0,.411.44,1.621,1.621,0,0,0,1.772.081,1.576,1.576,0,0,0,.449-.4,1.535,1.535,0,0,0,.262-.536,1.513,1.513,0,0,0,.033-.616l0-.011,0-.011,0-.011,0-.011-2.432-14.6a1.535,1.535,0,0,0-.215-.583,1.578,1.578,0,0,0-.412-.442A1.613,1.613,0,0,0,16.317,2.6l-.011,0-.011,0-.011,0ZM11.845,4.7c-.035.005-.071.012-.106.019s-.07.016-.1.026-.068.021-.1.033-.067.025-.1.04a20.869,20.869,0,0,0-7.827,5.772,20.633,20.633,0,0,0-1.868,2.6,1.519,1.519,0,0,0-.171,1.177,1.553,1.553,0,0,0,.262.539,1.578,1.578,0,0,0,.468.415,1.614,1.614,0,0,0,1.752-.08,1.551,1.551,0,0,0,.422-.457A17.6,17.6,0,0,1,7.982,10.63,17.754,17.754,0,0,1,12.7,7.686a1.583,1.583,0,0,0,.522-.347,1.555,1.555,0,0,0,.334-.5,1.527,1.527,0,0,0-.006-1.194,1.556,1.556,0,0,0-.285-.441,1.59,1.59,0,0,0-.4-.318A1.618,1.618,0,0,0,11.845,4.7Zm9.31-1.48a1.6,1.6,0,0,0-.582.243,1.58,1.58,0,0,0-.427.428,1.544,1.544,0,0,0-.232.554,1.543,1.543,0,0,0,.189,1.1,1.571,1.571,0,0,0,.323.383,1.6,1.6,0,0,0,.428.264,1.615,1.615,0,0,0,.5.12,18.095,18.095,0,0,1,10.137,4.2,1.6,1.6,0,0,0,.551.3,1.629,1.629,0,0,0,1.2-.087,1.59,1.59,0,0,0,.5-.38,1.552,1.552,0,0,0,.311-.54,1.537,1.537,0,0,0-.087-1.171,1.554,1.554,0,0,0-.387-.489A21.324,21.324,0,0,0,21.63,3.2c-.04,0-.08-.006-.119-.007s-.079,0-.119,0-.079.006-.119.011S21.194,3.215,21.155,3.223Zm-8.271,7.939q-.073.013-.143.032c-.047.013-.094.028-.139.045s-.091.036-.135.057-.087.044-.129.069a14.526,14.526,0,0,0-4.379,3.913,14.424,14.424,0,0,0-1.05,1.637A1.517,1.517,0,0,0,6.787,18.1a1.552,1.552,0,0,0,.283.528,1.585,1.585,0,0,0,.485.4A1.614,1.614,0,0,0,9.3,18.869a1.549,1.549,0,0,0,.4-.473,11.4,11.4,0,0,1,4.258-4.351,1.57,1.57,0,0,0,.474-.406,1.527,1.527,0,0,0,.113-1.716,1.563,1.563,0,0,0-.309-.377,1.6,1.6,0,0,0-.4-.262,1.619,1.619,0,0,0-.956-.121Zm9.385-1.489a1.606,1.606,0,0,0-.589.224,1.581,1.581,0,0,0-.44.414,1.546,1.546,0,0,0-.249.545,1.532,1.532,0,0,0,.136,1.065,1.559,1.559,0,0,0,.275.374,1.587,1.587,0,0,0,.375.279,1.614,1.614,0,0,0,.452.161,11.674,11.674,0,0,1,5.463,2.815,1.591,1.591,0,0,0,.536.325,1.629,1.629,0,0,0,1.2-.037,1.585,1.585,0,0,0,.515-.358,1.549,1.549,0,0,0,.333-.525,1.531,1.531,0,0,0-.037-1.171,1.552,1.552,0,0,0-.366-.5h0A14.883,14.883,0,0,0,22.9,9.689q-.078-.018-.157-.027t-.158-.012c-.053,0-.106,0-.159,0S22.321,9.663,22.269,9.672Zm-8.2,8.669a1.6,1.6,0,0,0-.563.222,1.58,1.58,0,0,0-.237.185,1.556,1.556,0,0,0-.2.228q-.154.209-.293.426t-.265.444q-.125.226-.236.459t-.206.473a1.514,1.514,0,0,0,.006,1.187,1.556,1.556,0,0,0,.338.495,1.591,1.591,0,0,0,.524.342,1.616,1.616,0,0,0,1.214,0,1.584,1.584,0,0,0,.505-.329A1.538,1.538,0,0,0,15,21.959l.005-.012,0-.012,0-.012,0-.012q.06-.149.128-.294t.147-.285q.078-.14.164-.275t.181-.264a1.525,1.525,0,0,0,.091-1.713,1.563,1.563,0,0,0-.423-.458,1.612,1.612,0,0,0-.594-.267,1.621,1.621,0,0,0-.653-.011Zm9.419-1.49a1.605,1.605,0,0,0-.591.217,1.576,1.576,0,0,0-.444.407,1.539,1.539,0,0,0-.255.54,1.526,1.526,0,0,0,.058.917,1.544,1.544,0,0,0,.14.276,1.576,1.576,0,0,0,.434.447q.133.094.259.2t.246.211q.12.109.232.225t.217.239a1.578,1.578,0,0,0,.491.387,1.627,1.627,0,0,0,1.19.107,1.6,1.6,0,0,0,.555-.292,1.554,1.554,0,0,0,.4-.48,1.524,1.524,0,0,0-.19-1.706h0q-.169-.2-.351-.387t-.374-.363q-.193-.176-.4-.339t-.415-.313a1.592,1.592,0,0,0-.274-.16,1.621,1.621,0,0,0-.929-.127Zm-3.854,5.742a2.4,2.4,0,0,0-.884.325,2.355,2.355,0,0,0-.664.61,2.3,2.3,0,0,0-.381.809,2.285,2.285,0,0,0,.3,1.785,2.354,2.354,0,0,0,.625.649,2.428,2.428,0,0,0,2.655.086,2.353,2.353,0,0,0,.664-.609,2.3,2.3,0,0,0,.382-.808,2.26,2.26,0,0,0,.036-.922,2.283,2.283,0,0,0-.333-.864A2.358,2.358,0,0,0,21.4,23a2.416,2.416,0,0,0-1.773-.41Z",
    transform: "translate(2184.48 224.738)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7643",
    "data-name": "Caminho 7643",
    d: "M2324.585,638.878H2133.553c-.211,0-.353-.116-.353-.289s.142-.289.353-.289h191.032c.211,0,.353.116.353.289S2324.8,638.878,2324.585,638.878Z",
    transform: "translate(0 -346.058)",
    fill: "#4d4d4d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedinsession);
export default __webpack_public_path__ + "static/media/Logged in session.c10d103f.svg";
export { ForwardRef as ReactComponent };